// extracted by mini-css-extract-plugin
export default {"container":"LabelField_container__KB9Zp","content-label":"LabelField_content-label__fdmQ1","info-exclamation":"LabelField_info-exclamation__847km"};